import * as angular from "angular";
import {IController} from "angular";

export class siteModulesViewCtrl implements IController {

  module: any;
  subModules: any;
  onToggle: Function;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.site-preferences')
  .component('siteModuleListItem', {
    bindings: {
      module: '<',
      subModules: '<?',
      onToggle: '&'
    },
    template: require('./site-module-list-item.html').default,
    controller: siteModulesViewCtrl
  });
